import { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'

import { DrawerBodyWrapper, Table, TOAST_TYPE } from '@base'
import { strings } from '@constants'
import { getPastMonthTargets } from '@data'
import { showLoader, showToast } from '@data/state/action'
import { displayAmount } from '@utils'

const MonthlyTargetHistory = ({ data }) => {
	const dispatch = useDispatch()
	const [targetHistory, setTargetHistory] = useState([])

	useEffect(() => {
		dispatch(showLoader(true))
		getPastMonthTargets(data?.user_id)
			.then((response) => {
				setTargetHistory(response)
			})
			.catch((error) => {
				dispatch(showToast(true, strings('msg_error_fetching_targets_history'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}, [data])

	const columns = useMemo(() => {
		return [
			// { key: 'start_month_year', label: strings('start_month'), align: 'center' },
			// {
			// 	key: 'end_month_year',
			// 	label: strings('end_month'),
			// 	align: 'center',
			// },
			{
				key: 'month_year',
				label: strings('month'),
				mobile: true,
			},
			{
				label: strings(['monthly_target']),
				key: (value) => {
					return displayAmount(value?.target)
				},
				mobile: true,
			},
			{
				label: strings(['target_achieved']),
				key: (value) => {
					return displayAmount(value?.achieved)
				},
				mobile: true,
			},
		]
	}, [])

	return (
		<>
			<DrawerBodyWrapper>
				<Table
					columns={columns}
					data={targetHistory ?? []}
					rowsToDisplay={10}
					totalItemCount={targetHistory?.length}
					page={0}
					rowClickable={false}
					hideFooter
					fullHeights
					noScroll
				/>
			</DrawerBodyWrapper>
		</>
	)
}

export default MonthlyTargetHistory
